import {useTranslation} from "react-i18next";

export default function EventListPrice({prices, isFinished}) {
    const { t } = useTranslation();

    if (!!prices.length && !isFinished) {
        return <>{prices[0].amount}
            <icon className={`icon-${prices[0].currency.code}`} /></>
    }
    if (!prices.length && !isFinished) {
        return t('conferences.conference.free');
    }

    return t('conferences.conference.finished');
}
